define(function (require) {

    var _ = require('underscore');
    var lpMessagingEngagementHistoryTransformationHelper = require('web-agent-adapters/lpMessagingEngagementHistoryTransformationHelper');
    var lpMessagingEngagementHistoryTableAdapter = require('web-agent-adapters/lpMessagingEngagementHistoryTableAdapter');
    var BASE = require('web-agent-adapters/BaseAdapter');
    var MAX_RECORDS_LIMIT = 100;
    var transformationHelper = lpMessagingEngagementHistoryTransformationHelper;

    var lpMessagingEngagementHistoryWidgetAdapter = BASE.extend(function (options) {
    });

    lpMessagingEngagementHistoryWidgetAdapter.prototype.applicationType = "lpMessagingEngagementHistoryWidgetAdapter";

    lpMessagingEngagementHistoryWidgetAdapter.prototype.getConsumerHistory = function (request) {
        // align with the interface.
        // Default search for the service.
        request.query = {
            offset: 0,
            limit: MAX_RECORDS_LIMIT,
            sort: "start:desc"
        };
        request.data = {
            consumer: request.consumerId,
            contentToRetrieve: lpMessagingEngagementHistoryTableAdapter.CONTENT_BLOCKS.BASE,
            status: ["CLOSE"]
    };

        var decoratedRequestObject = decorateRequestObject(request);
        return this.service.searchEngagementsByConsumer(decoratedRequestObject);
    };

    function decorateRequestObject(request) {
        var successHandler = request.success;
        var errorHandler = request.error;

        if (_.isFunction(successHandler)) {
            request.success = function (response) {
                var transformedData = transformResponse(response);
                if (transformedData) {
                    successHandler(transformedData);
                } else if (_.isFunction(errorHandler)) {
                    errorHandler({
                        error: 'transformation failed, invalid data.'
                    });
                }
            };
        }
        return request;
    }

    function transformResponse(response) {
        if (response && response.body && response.body._metadata && response.body.conversationHistoryRecords) {
            var data = getData(response.body.conversationHistoryRecords);
            var count = response.body._metadata.count;
            var cSatStatistics = getCalculatedCSATStatistics(response.body.conversationHistoryRecords);
            return {
                count: count,
                data: data,
                cSatStatistics: cSatStatistics
            };
        }

        // Converting the records to chat model.
        function getData(conversationHistoryRecords) {
            return _.map(conversationHistoryRecords, function (item) {
                return getSingleRecordModel(item);
            });
        }

        function getSingleRecordModel(recordData) {
            transformationHelper.transformConsumerNameBySDEs(recordData);
            transformationHelper.normalizeAgentsParticipantsList(recordData);

            var agentInfo = transformationHelper.getAssignedAgent(recordData);
            return {
                info: getInfoObject(),
                transcript: getTranscriptObject(),
                data: getDataObject()
            };

            // NOTE: all the data that will be set in the info object will be reflected in the UI
            // on the History Widget. if you need somewhere to put metadata, use the Data object mapping.
            function getInfoObject() {
                return {
                    startTime: recordData.info.startTimeL,
                    endTime: recordData.info.endTimeL,
                    conversationId: recordData.info.conversationId,
                    latestAgentId: recordData.info.latestAgentId
                };
            }

            function getTranscriptObject() {
                var chatTranscript = transformationHelper.getTranscript(recordData, recordData.dialogs);
                if (recordData.dialogs) {
                    lpTag.WebAgent.logicController.addIndicationToStartAndEndDialogLines(chatTranscript, getFormattedDialogs());
                }
                return {
                    line: chatTranscript
                };
            }

            function getFormattedDialogs() {
                var conversationDialogs = {};
                _.each(recordData.dialogs, function (dialog) {
                    conversationDialogs[dialog.dialogId] = {
                        participantsDetails: dialog.participantsDetails,
                        dialogId: dialog.dialogId,
                        state: dialog.status,
                        dialogType: dialog.dialogType,
                        channelType: dialog.dialogChannelType,
                        startTs: dialog.startTimeL,
                        endTs: dialog.endTimeL,
                        closedBy: dialog.closeReason
                    };
                });
                return conversationDialogs;
            }

            function getDataObject() {
                return {
                    conversationId: recordData.info.conversationId,
                    note:  transformationHelper.getAgentSummary(recordData),
                    isConversationResolved: transformationHelper.getSatisfactionSurvey(recordData),
                    csatRate: recordData.info.csatRate,
                    skillId: recordData.info.latestSkillId != -1 ? recordData.info.latestSkillId : '',
                    agentName: transformationHelper.getAgentName(agentInfo),
                    isPartial: recordData.info.isPartial,
                    agentDeleted: recordData.info.agentDeleted
                };
            }
        }
    }

    function getCalculatedCSATStatistics(conversationHistoryRecords) {
        var cSatAVG = 0, cSatCount = 0, satisfyScoreCount = 0;

        // iterate over all the conversations of the visitor, if csat rate exist, promote the counter for the divider
        for (var i = 0; i < conversationHistoryRecords.length; i++) {
            var csatRate = conversationHistoryRecords[i].info.csatRate;
            if (csatRate > 0) {
                cSatCount++;
            }
            if (csatRate > 3) {
                satisfyScoreCount++;
            }
        }

        if (cSatCount > 0) {
            cSatAVG = (satisfyScoreCount / cSatCount * 100);
        }

        cSatAVG = (cSatAVG % 1 > 0) ? cSatAVG.toFixed(0) : cSatAVG;
        var percentText = cSatCount ? cSatAVG + '%' : '';
        return {
            average: cSatAVG,
            fillCount: cSatCount,
            percentText: percentText,
            conversationCount: conversationHistoryRecords.length || 0
        };
    }

    return lpMessagingEngagementHistoryWidgetAdapter;

});
